import { Card } from 'antd';
import type { EmployeeStates } from '../../../../../../app/features/employee/emp-dashboard/emp-dashboard.type';

import ClockIcon from './_icons/ClockIcon';
import MultiUsersIcon from './_icons/MultiUsersIcon';
import PaymentIcon from './_icons/PaymentIcon';
import RatingIcon from './_icons/RatingIcon';
import SingleUserIcon from './_icons/SingleUserIcon';

interface DashboardAttendanceCardProps {
  employeeStats?: EmployeeStates;
  isLoading?: boolean;
}

export default function DashboardAttendanceCard({
  employeeStats,
  isLoading = false,
}: DashboardAttendanceCardProps) {
  // Convert overtime minutes to hours and format
  const overtimeHours = employeeStats
    ? `${Math.floor(employeeStats.overtime_minutes / 60)}H`
    : '0H';
    
  const cardData = [
    {
      icon: <MultiUsersIcon className="text-[32px] text-gray-300" />,
      value: employeeStats ? employeeStats.total_employees?.toString() : '0',
      title: 'Total Employee',
    },
    {
      icon: <SingleUserIcon className="text-[32px] text-gray-300" />,
      value: employeeStats ? employeeStats.present_employees?.toString() : '0',
      title: 'Present Employee',
    },
    {
      icon: <ClockIcon className="text-[32px] text-gray-300" />,
      value: overtimeHours,
      title: 'Over Time Hours',
    },
    {
      icon: <PaymentIcon className="text-[32px] text-gray-300" />,
      value: employeeStats ? employeeStats.on_leave_employees?.toString() : '0',
      title: 'On Leave',
    },
  ];

  return (
    <>
      <div className="flex justify-start overflow-x-auto hide-scrollbar md:grid md:grid-cols-2 gap-6">
        {cardData.map((card, index) => (
          <Card
            key={index}
            className="dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-xl text-white shadow-md"
            bodyStyle={{ padding: '22px' }}
            loading={isLoading}
          >
            <div className="flex flex-col gap-4 !w-52 !md:w-[full]">
              {/* Icon */}
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                {card.icon}
              </div>

              {/* Value */}
              <div className="justify-start text-white text-2xl font-bold">
                {card.value}
              </div>

              {/* Growth */}
              <div className="flex items-center gap-2 text-teal-500 font-normal">
                <span className="text-xl">
                  <RatingIcon />
                </span>
                <span>12.5%</span>
              </div>

              {/* Title */}
              <div className="text-white text-sm font-normal">{card.title}</div>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
